import Nav from './NavBar.vue'
import DataGrid from './DataGrid.vue'
import SegmentedCircle from './SegmentedCircle.vue'
import BonusTracker from './BonusTracker.vue'
import ActionCalendar from './ActionCalendar.vue'
import ActionEditor from './ActionEditor.vue'
import ActionKanban from './ActionKanban.vue'
import ActionDatatable from './ActionDatatable.vue'
import ActionFilter from './ActionFilter.vue'
import PlanEditor from './PlanEditor.vue'
import UserGuide from './UserGuide.vue'
import type { App } from 'vue'

export const components = (app: App) => {
  app.component('NavBar', Nav)
  app.component('DataGrid', DataGrid)
  app.component('SegmentedCircle', SegmentedCircle)
  app.component('BonusTracker', BonusTracker)
  app.component('ActionCalendar', ActionCalendar)
  app.component('ActionEditor', ActionEditor)
  app.component('ActionKanban', ActionKanban)
  app.component('ActionDatatable', ActionDatatable)
  app.component('ActionFilter', ActionFilter)
  app.component('PlanEditor', PlanEditor)
  app.component('UserGuide', UserGuide)
}
